import { Grid } from '@material-ui/core';
import { CKEditor } from 'ckeditor4-react';
import useDebounceSearch from 'EurestoHook/useDebounceSearch';
import React, { useEffect, useState } from 'react';
var h2p = require('html2plaintext')

export default (props) => {
  const [content, setContent] = useState(`${(props.value || '')}`)
  const [maxHeight, setMaxHeight] = useState(props.maxHeight || '100%')
  const debounceContent = useDebounceSearch(content, 300)

  if (props.onChange) {
    useEffect(
      () => {
        if (debounceContent !== undefined) {
          if (debounceContent !== props.value) {
            props.onChange((debounceContent || ''), props.name)
          }
        }
      },
      [debounceContent]
    )
  }

  return (
    <Grid container justify={'flex-start'} spacing={0} style={{
      margin: 0,
      padding: 0,
      width: '100%',
      minWidth: '100%',
      height: maxHeight,
      maxHeight: maxHeight,
      position: 'relative',
      textAlign: 'left'
    }} alignItems={'stretch'} className='Euresto-Wysiwyg'>

      <CKEditor
        config={{
          width: '100%',
          height: '100%',
          enterMode: 2, //CKEDITOR.ENTER_BR
          shiftEnterMode: 2,
          readOnly: props.disabled,
          extraPlugins: 'colorbutton,font,uploadimage',
	  versionCheck: false,
          toolbarGroups: [
            { name: 'document', groups: ['mode', 'document', 'doctools'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'colors', groups: ['colors'] },
            { name: 'tools', groups: ['tools'] },
            { name: 'others', groups: ['others'] },
            { name: 'about', groups: ['about'] },
            '/',
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'forms', groups: ['forms'] },
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] }
          ],
          removeButtons: 'Format,Styles,Maximize,ShowBlocks,About,Source,Save,NewPage,ExportPdf,Preview,Print,Templates,Cut,Copy,Paste,PasteFromWord,PasteText,Find,Replace,SelectAll,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Form,CopyFormatting,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Unlink,Anchor,Iframe,Superscript,Subscript,Smiley,SpecialChar,PageBreak'
        }}
        initData={content}
        onChange={(event) => {
          console.log(event.editor, event.editor.getData())
          setContent(event.editor.getData())
        }}
      />
      {/* <TextareaAutosize value={content} disabled={props.disabled || props.readOnly} onChange={(event) => { setContent(event.target.value) }} style={{ height: '100%', width: '100%' }} /> */}
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./app/Components/Wysiwyg.js